import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import Swal from 'sweetalert2'
import Constant from '../../../Constant.js'
import axios from 'axios'
import Select from 'react-select'

class CarPickupAdd extends React.Component {
  state = {
    isData: false,
    pickupList: [],
    pickup_data: null,
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  async componentDidMount() {
    await this.getPickupList()
  }

  getPickupList = async () => {
    await axios
      .get(Constant.getAPI() + `/admin/pick-up-listing`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            pickupList: res.data?.data?.map((itm) => ({
              label: `${itm.pickup_address_en}/${itm.pickup_address_ar}`,
              value: itm.id,
            })),
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  addItem = () => {
    let data = {
      pickup_id: this.state.pickup_data?.value,
    }

    this.setState({ isData: true })
    axios
      .post(Constant.getAPI() + '/car/create-pickup', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Pickup Added Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        window.location.href = `#/car-pickup`
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSaveData = () => {
    if (!this.state.pickup_data?.value) {
      Swal.fire({
        title: 'Pickup location is required',
        icon: 'error',
        text: "The value in this field can't be empty",
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })
      return false
    }
    this.addItem()
  }

  handleStateChange = (event) => {
    this.setState({ pickup_data: event })
  }

  handlePickupChange = (event) => {
    this.setState({ pickup_data: event })
  }

  handleClear = () => {
    this.setState({ pickup_data: null })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">Select Pickup Location</label>
                <div className="col-sm-8">
                  <Select
                    name="pickup_data"
                    value={this.state.pickup_data}
                    onChange={this.handleStateChange}
                    options={this.state.pickupList}
                    isMulti={false}
                    isSearchable={true}
                    isClearable
                    onClear={this.handleClear}
                    placeholder="Select Options"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card-footer">
            <div className="row">
              <div className="text-right col-6 offset-6">
                <Link
                  to={`/car-pickup`}
                  className="btn btn-outline-secondary m-2 "
                >
                  <i className="icofont icofont-rounded-double-left"></i>
                  Back
                </Link>
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Saving...!
                  </button>
                ) : (
                  <button
                    onClick={this.onSaveData}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(CarPickupAdd)
